"use client";
import {
  NextUIProvider
} from "./chunk-PYQ4KYZP.mjs";
import {
  ProviderContext,
  useProviderContext
} from "./chunk-Q66YAGZJ.mjs";

// src/index.ts
import {
  forwardRef,
  toIterator,
  mapPropsVariants,
  mapPropsVariantsWithCommon,
  isNextUIEl,
  extendVariants
} from "@nextui-org/system-rsc";
export {
  NextUIProvider,
  ProviderContext,
  extendVariants,
  forwardRef,
  isNextUIEl,
  mapPropsVariants,
  mapPropsVariantsWithCommon,
  toIterator,
  useProviderContext
};
